import { twMerge } from 'tailwind-merge';

export const LikeCircleIcon = ({ className }: { className?: string }) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#FFCECB" />
    <path
      d="M28 37.33L26.98 36.4C24.26 33.92 22.09 31.75 20.45 29.9C18.82 28.05 18 26.17 18 24.28C18 22.78 18.5 21.52 19.51 20.51C20.52 19.5 21.77 19 23.25 19C24.1 19 24.94 19.2 25.77 19.61C26.6 20.02 27.34 20.69 28 21.62C28.73 20.69 29.49 20.02 30.27 19.61C31.05 19.2 31.88 19 32.75 19C34.23 19 35.48 19.5 36.49 20.51C37.5 21.52 38 22.77 38 24.27C38 26.17 37.18 28.04 35.55 29.89C33.92 31.74 31.74 33.91 29.03 36.39L28.01 37.32L28 37.33Z"
      fill="#FA4549"
    />
    <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" stroke="black" strokeOpacity="0.1" />
  </svg>
);
